/**
 *
 * ListFilters
 *
 */

/* eslint-disable react/destructuring-assignment */

import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import { withStyles } from '@material-ui/core/styles'

// eslint-disable-next-line no-unused-vars
// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  stgInput: {
    '& >input': {
      padding: '7px',
    },
  },
})

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
const BorderedInput = (classes, ContainterStyle, value, onChange, readOnly, ...rest) => (
  <FormControl fullWidth className={classes.margin}>
    <Input id="input" value={value} onChange={onChange} className={classes.stgInput} readOnly={readOnly} {...rest} />
  </FormControl>
)

BorderedInput.defaultProps = {}

export default withStyles(styles)(BorderedInput)
